import { useEffect } from "react";

import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";

import FormField from "../../../layouts/ecommerce/products/new-product/components/FormField";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
/* import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker"; */
/* import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"; */

// Material Dashboard 2 PRO React components
import MDTypography from "../../../components/MDTypography";
import MDInput from "../../../components/MDInput";
import MDBox from "../../../components/MDBox";

import { getModels } from "../../../api/models";

import { statusEnum, situationDescriptionEnum } from "../../../config/enum";

export default function RefInfos({
  refs,
  step,
  edit,
  supplier,
  setSupplier,
  suppliers,
  model,
  setModel,
  models,
  setModels,
  supplierRef,
  setSupplierRef,
}) {
  async function fetchModels() {
    const response = await getModels({ "tblmodel.supplier_id": supplier.id });
    const formatedModels = await response.data.map((model) => ({
      label: model.model_name,
      id: model.model_id,
    }));
    setModels(formatedModels);
  }

  useEffect(() => {
    if (supplier) {
      fetchModels();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [supplier]);

  useEffect(() => {
    if (edit) {
      if (refs[step].model_id !== null && models.length >= 1) {
        setModel(models.find((model) => model.id === refs[step].model_id));
      } else {
        setModel([]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [models]);

  return (
    <MDBox>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <Autocomplete
            options={suppliers}
            value={supplier}
            onChange={(event, newSupplier) => {
              setSupplier(newSupplier);
            }}
            renderInput={(params) => (
              <MDInput {...params} label="Choisissez le fournisseur" variant="standard" />
            )}
          />
        </Grid>
        <Grid item xs={4}>
          <Autocomplete
            options={models}
            value={model}
            disabled={!supplier}
            onChange={(event, newModel) => {
              setModel(newModel);
            }}
            renderInput={(params) => (
              <MDInput {...params} label="Choisissez le modèle" variant="standard" />
            )}
          />
        </Grid>
        <Grid item xs={4}>
          <FormField
            inputProps={{ maxLength: 255 }}
            value={supplierRef}
            onChange={(event) => setSupplierRef(event.target.value)}
            variant="standard"
            type="text"
            label="Référence fournisseur"
          />
        </Grid>
      </Grid>
    </MDBox>
  );
}
